var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1024 1024",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 960) scale(1, -1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M184.32 719.36c0 14.139 11.461 25.6 25.6 25.6h604.16c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-604.16c-14.139 0-25.6 11.461-25.6 25.6zM286.72 540.16c0-28.277-22.923-51.2-51.2-51.2s-51.2 22.923-51.2 51.2c0 28.277 22.923 51.2 51.2 51.2s51.2-22.923 51.2-51.2zM235.52 304.64c28.277 0 51.2 22.923 51.2 51.2s-22.923 51.2-51.2 51.2c-28.277 0-51.2-22.923-51.2-51.2s22.923-51.2 51.2-51.2zM286.72 171.52c0-28.277-22.923-51.2-51.2-51.2s-51.2 22.923-51.2 51.2c0 28.277 22.923 51.2 51.2 51.2s51.2-22.923 51.2-51.2zM373.76 570.88c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h440.32c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6h-440.32zM348.16 360.96c0 14.139 11.461 25.6 25.6 25.6h440.32c14.139 0 25.6-11.461 25.6-25.6s-11.461-25.6-25.6-25.6h-440.32c-14.139 0-25.6 11.461-25.6 25.6zM373.76 202.24c-14.139 0-25.6-11.461-25.6-25.6s11.461-25.6 25.6-25.6h440.32c14.139 0 25.6 11.461 25.6 25.6s-11.461 25.6-25.6 25.6h-440.32z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/role.b5650a7992f05b333c37cdd588214a56.svg";
export { ForwardRef as ReactComponent };